/* ==================================================
  c_product-label-staff.js — 商品一覧「Web限定」「一部Web限定」ラベル（客注モード専用）
  spec: 03_客注モード_FE §2.6.3 / §2.6.6
  - 客注モード（CStaffSession のトークンあり）のときだけ表示する。通常の EC では何もしない。
  - <product-item data-staff-label data-web-limited> の判定データを window.CWebLimited で判定する
    （全バリアントが対象 → 「Web限定」、一部 → 「一部Web限定」、なし → 表示しない）。
  - ページはキャッシュされるため判定はブラウザの JST 当日日付で行い、bfcache から戻ったとき
    （pageshow の persisted）も判定し直す。
  - AJAX のページ送り・絞り込みでカードが差し替わったら MutationObserver で再判定する。
  ===================================================*/
(function () {
  'use strict';

  var SEL_CARD = 'product-item[data-staff-label]';
  /* 機能タグの行が無いカードでは、ブランド名・商品名ブロックの直前に行を作る */
  var ANCHOR = '.c_product-item-meta, .product-item-meta';
  var timer = null;

  function renderStaffLabels() {
    var W = window.CWebLimited;
    if (!W) return;
    var staff = W.isStaffMode();
    var items = document.querySelectorAll(SEL_CARD);
    for (var i = 0; i < items.length; i++) {
      var status = staff ? W.productStatus(W.dataOf(items[i])) : 'none';
      W.paintCardLabel(items[i], status, ANCHOR);
    }
  }

  function scheduleRender() {
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      renderStaffLabels();
    }, 50);
  }

  function initialize() {
    renderStaffLabels();
    if (typeof MutationObserver !== 'function' || !document.body) return;
    var target = document.querySelector('#facet-main') || document.querySelector('.product-facet__main') || document.body;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType === 1 && (node.tagName === 'PRODUCT-ITEM' || (node.querySelector && node.querySelector('product-item')))) {
            scheduleRender();
            return;
          }
        }
      }
    }).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) renderStaffLabels();
  });
  document.addEventListener('shopify:section:load', renderStaffLabels);
})();
